export const staticRoutes = {
  home: '/home',
  sportsbook: '/sportsbook',
  racing: '/racing',
  live: '/live',
  clientProfile: '/account',
  results: '/results',
  forgotPassword: '/forgotPassword',
  casino: '/casino',
  casinoGame: '/casino/game',
  casinoFavorites: '/casino/favorites',
  liveCasino: '/live-casino',
  liveCasinoGame: '/live-casino/game',
  tvGames: '/betgames',
  promotions: '/promotions',
  bespokeMarkets: '/specials',
  promotionTournaments: '/promotion-tournaments',
  signin: '/signin',
  signup: '/signup',
  staticPage: '/page'
}
